module.exports = __webpack_public_path__ + "static/img/cePath2.cd6be6ab.gif";